import { render, staticRenderFns } from "./AppContent.vue?vue&type=template&id=747bb174"
import script from "./AppContent.vue?vue&type=script&lang=js"
export * from "./AppContent.vue?vue&type=script&lang=js"
import style0 from "./AppContent.vue?vue&type=style&index=0&id=747bb174&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports